import logo from './logo.svg';
import './Style/App.css'
import Background from './Background';
import Boat from './Boat';
import Banner from './Banner';

import AboutMe from './Pages/About Me';
import Projects from './Pages/Projects';
import Experience from './Pages/Experience';
import Links from './Pages/Links';
import { useState } from 'react';

function App() {
    const [currentVisible,setVisible] = useState(-1);

  return (
    
    <div className="App">
    <Banner/>
    <Boat/>
    <Background setVis={setVisible} curVis={currentVisible}/>
    {/* Every page stays mounted so its text is in the page for search engines
        to read. Only the open one is shown, the rest are hidden in css */}
    <AboutMe setVis={setVisible} visible={currentVisible === 0}/>
    <Projects setVis={setVisible} visible={currentVisible === 1}/>
    <Experience setVis={setVisible} visible={currentVisible === 2}/>
    <Links setVis={setVisible} visible={currentVisible === 3}/>
    </div>
  );
}

export default App;
